module.exports = __webpack_public_path__ + "static/media/leather-shoes.e3abd1e3.jpg";